type OMITTED_VALUES = 'createdAt' | 'updatedAt' | 'ethnicity' | 'sex';

export interface EthnicityType {
  id: number;
  displayName: string;
}

export interface SexType {
  id: number;
  displayName: string;
}

export interface PatientModel {
  id: string;
  title: string;
  firstName: string;
  lastName: string;
  email?: string;
  telephone?: string;
  telephone_code?: string;
  dateOfBirth: string;
  parentalMyopia: string;
  consentData?: Record<string, any>;

  ethnicity_id: number;
  sex_id: number;
  org_id: string;

  createdAt: string;
  updatedAt: string;

  ethnicity: EthnicityType;
  sex: SexType;
}

export interface PatientPageModel {
  data: PatientModel[];
  total: number;
  page: number;
  limit: number;
}

export const EMPTY_PATIENT_PAGE_MODEL: PatientPageModel = {
  data: [],
  total: 0,
  page: 1,
  limit: 10,
};

export interface CreatePatientModel extends Omit<PatientModel, 'id' | OMITTED_VALUES> {}
export interface UpdatePatientModel extends Partial<Omit<PatientModel, OMITTED_VALUES>> {}
